<template>
  <div class="address relative">
    <input
      type="text"
      class="complete-address form-input"
      v-model="address"
      :disabled="disabled"
      :placeholder="$t('global.completeAddress')"
      @keyup="handleGeolocation"
      @input="handleInput"
    />
    <UiSpinner
      v-if="isLoading"
      size="sm"
      style="position: absolute; right: 10px; top: 11px; pointer-events: none"
    />
    <div
      class="autocomplete-result"
      v-if="result"
      v-click-outside="onClickOutside"
    >
      <ul>
        <li v-for="(item, index) in result" @click="chooseAddress(index)">
          {{ item.address }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import axios from "axios";
import API from "@/services/API";
import vClickOutside from "v-click-outside";
import UiSpinner from "@/components/ui/UiSpinner";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      address: "",
      result: null,
      selectedLocation: null,
      isLoading: false,
    };
  },
  components: {
    UiSpinner,
  },
  methods: {
    handleGeolocation: debounce(function () {
      if (this.address && this.address.length > 2) {
        this.geocode();
      }
    }, 1000),

    geocode: function () {
      this.isLoading = true;
      axios
        .get(API.endpoints.plans.geocoding + this.address)
        .then((response) => {
          this.result = (response?.data?.message || []).map((result) => ({
            address: result.label,
            center: {
              lng: result.point.lon,
              lat: result.point.lat,
            },
          }));
          this.isLoading = false;
        });
    },

    chooseAddress(index) {
      const chosen = this.result[index];
      this.address = chosen.address;
      this.selectedLocation = chosen;
      this.emitLocation();
      this.result = null;
    },

    handleInput() {
      this.emitLocation();
    },

    emitLocation() {
      this.$emit("location", {
        address: this.address,
        center: this.selectedLocation ? this.selectedLocation.center : null,
      });
    },

    onClickOutside() {
      this.result = null;
    },
  },
  name: "",
  props: {
    center: {
      default: function () {
        return null;
      },
    },
    zoom: {
      default: null,
    },
    fullAddress: {
      type: String,
      default: "",
    },
    disabled: {
      default: false,
    },
  },
  updated: function () {},
  watch: {
    fullAddress(newVal) {
      this.address = newVal;
    },
  },
};
</script>

<style lang="scss" scoped></style>
